import { Box, Typography } from '@mui/material';
import React from 'react';

const TotalCard = ({ data, background, text }) => {
  return (
    <Box
      style={{
        background: background,
        padding: '5px 10px',
        borderRadius: '3px',
      }}
    >
      <Typography
        style={{
          color: 'var(--secondary-color)',
          fontSize: '12px',
          fontWeight: 500,
        }}
      >
        {text || ''}
      </Typography>
      <Typography
        style={{
          color: 'var(--secondary-color)',
          fontSize: '25px',
          textAlign: 'right',
          fontWeight: 500,
        }}
      >
        {data || 0}
      </Typography>
    </Box>
  );
};

export default TotalCard;
